module.exports = __webpack_public_path__ + "img/common-file-check.e0ed516e.svg";